// The REPEATABLE-slot convention of a view's `roleNames` (a role bound several
// times): the first binding under the role's own name, the next ones under
// `<role>::1`, `<role>::2`, … in key order. ONE reader, so the engine's
// dimensions (a pivot's two `group`s) and the table's hierarchy levels (SEN-430)
// read bindings the same way.
export function repeatableBindings(roleNames: Record<string, unknown> | null | undefined, role: string): string[] {
  if (!roleNames) return []
  return Object.keys(roleNames)
    .filter((k) => k === role || k.startsWith(`${role}::`))
    .sort()
    .map((k) => roleNames[k])
    .filter((v): v is string => typeof v === 'string' && v !== '')
}
